<template>
  <!-- 패널 -->
  <div
    class="container-peekingpanel"
    :class="{ open: modelValue, closed: !modelValue }"
    :style="{ width }"
  >
    <!-- 왼쪽핸들 -->
    <button
      class="button-icon button-dim button-rounded button-icon-small"
      type="button"
      @click="togglePanel"
    >
      <component :is="modelValue ? IconChevronRight : IconChevronLeft" />
    </button>

    <!--콘텐츠-->
    <section class="panel-content">
      <slot />
    </section>
  </div>
</template>

<script setup lang="ts">
import IconChevronLeft from '@/components/icons/IconChevronLeft.vue';
import IconChevronRight from '@/components/icons/IconChevronRight.vue';

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    width?: string;
  }>(),
  {
    width: '22rem',
  }
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'close'): void;
}>();

const togglePanel = () => {
  emit('update:modelValue', !props.modelValue);
};

const closePanel = () => {
  emit('update:modelValue', false);
  emit('close');
};
</script>

<style scoped lang="scss">
.container-peekingpanel {
  position: absolute;
  display: flex;
  right: 0;
  height: 100%;
  padding: 0 1rem 0 1.5rem;
  background: var(--surface-default);
  z-index: $z-modal;
  box-shadow: $shadow-modal;
  cursor: pointer;

  /* 닫혔을때 : 패널 일부만 보이게 */
  &.closed {
    transform: translateX(calc(100% - 1.5rem));
  }

  /* 열렸을때 */
  &.open {
    transform: translateX(0);
  }
}

.panel-content {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  overflow: hidden;
}

.button-icon {
  position: absolute;
  left: -1rem;
  top: 0.875rem;
  box-shadow: $shadow-button;
}
</style>
